/*
    创建者：shuxiaokai
    创建时间：2020-05-14 15:26
    模块名称：鼠标右键实例
    备注：xxxx
*/
<template>
    <div class="context-mennu" :style="{left: left + 'px', top: top + 'px'}">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        left: {
            type: Number,
            default: 0,
        },
        top: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {

        };
    },
    mounted() {
        // this.initPosition(); //初始化位置
    },
    methods: {
        //=====================================组件间交互====================================//  
        // initPosition() {

        // }
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.context-mennu {
    position: fixed;
    width: size(240);
    padding: size(4) 0;
    // height: size(300);
    z-index: 2020;
    background: $white;
    box-shadow: $box-shadow;
    animation: scale .2s;
    @keyframes scale {
        from {
            opacity: 0;
            transform: scale(0.8)
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
}
</style>
